import { useDelete, useUpdate } from '@/data/mutations';
import type { INotification, ResponseType } from '@/types';

export const useUpdateNotifications = useUpdate.notifications<{ ids: string[] }, ResponseType<INotification[]>>({
    endpoint: () => 'user/notifications',
    body: ({ ids }) => ({ read: ids }),
});

export const useDeleteNotification = useDelete.notification<{ id: string }, ResponseType<INotification[]>>({
    method: 'DELETE',
    endpoint: ({ id }) => `user/notifications/${id}`,
});
